import { useState } from 'react'
import { baseTicker, coinIconUrl } from './coinIcons'

// Monogram colours: a stable pick per ticker, so a coin keeps its colour.
const MONOGRAM_COLOURS = [
  'bg-sky-600',
  'bg-emerald-600',
  'bg-violet-600',
  'bg-amber-600',
  'bg-rose-600',
  'bg-teal-600',
  'bg-indigo-600',
  'bg-fuchsia-600',
]

const colourFor = (ticker: string) => {
  let h = 0
  for (const c of ticker) h = (h * 31 + c.charCodeAt(0)) >>> 0
  return MONOGRAM_COLOURS[h % MONOGRAM_COLOURS.length]
}

interface CoinIconProps {
  /** Any form: "BTC/USDT", "BTC", "KAS.F". */
  symbol: string
  size?: number
  className?: string
}

/**
 * A coin's icon from cryptocurrency-icons, or a coloured monogram badge for
 * coins the package doesn't carry (and if an icon fails to load).
 */
const CoinIcon = ({ symbol, size = 20, className = '' }: CoinIconProps) => {
  const ticker = baseTicker(symbol)
  const url = coinIconUrl(symbol)
  const [failed, setFailed] = useState(false)
  const box = { width: size, height: size }

  if (url && !failed) {
    return (
      <img
        src={url}
        alt=""
        aria-hidden="true"
        style={box}
        className={`inline-block shrink-0 rounded-full ${className}`}
        onError={() => setFailed(true)}
        data-testid="coin-icon"
      />
    )
  }
  const letters = ticker.toUpperCase().slice(0, ticker.length > 3 ? 2 : 3)
  return (
    <span
      aria-hidden="true"
      style={{ ...box, fontSize: Math.max(Math.round(size * (letters.length > 2 ? 0.34 : 0.42)), 7) }}
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold leading-none text-white ${colourFor(ticker)} ${className}`}
      data-testid="coin-monogram"
    >
      {letters}
    </span>
  )
}

export default CoinIcon
